export const convertToNegativeTotal = (total: string) => (parseFloat(total) * -1).toFixed(2);
